<template>
  <div
    class="zj-layout-main-content bgcolor scrollable"
    style="overflow: auto; height: 98%"
  >
    <el-form
      :model="ruleForm"
      :rules="rules"
      ref="ruleForm"
      label-width="16rem"
      style="width: 80%"
    >
      <zj-layout-container>
        <zj-layout-header>
          <div class="listtitle">紧急求助详情</div>
        </zj-layout-header>
      </zj-layout-container>
      <!-- prop="ResourceName" -->

      <el-row>
        <el-col :span="12">
          <el-form-item label="提交日期" prop="createdate">
            <el-date-picker
              v-model="ruleForm.createdate"
              type="date"
              placeholder="选择日期"
              value-format="yyyy-MM-dd"
              disabled
              style="width: 100%"
            ></el-date-picker>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="状态" prop="status">
            <el-input v-model="status" disabled></el-input>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="12">
          <el-form-item label="电话" prop="phone">
            <el-input v-model="ruleForm.phone" disabled></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="经纬度" prop="location">
            <el-input v-model="location" disabled></el-input>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="12">
          <el-form-item label="姓名" prop="name">
            <el-input v-model="ruleForm.name" disabled></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="地址" prop="address">
            <el-input v-model="ruleForm.address" disabled></el-input>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="24">
          <el-form-item label="描述" prop="des">
            <el-input
              v-model="ruleForm.description"
              type="textarea"
              disabled
            ></el-input>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="24">
          <div class="mapBox">
            <div
              class="map"
              id="allmap"
              style="width: 100%; height: 100%"
            ></div>
            <!-- <div class="coverbg"></div> -->
          </div>
        </el-col>
      </el-row>
      <el-row v-if="!showResult">
        <el-col :span="24">
          <el-form-item label="回复" prop="result">
            <el-input
              v-model="ruleForm.result"
              placeholder="请输入回复"
              type="textarea"
            ></el-input>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row v-if="showResult">
        <el-col :span="24">
          <el-form-item label="处理结果" prop="result">
            <el-input
              v-model="ruleForm.result"
              type="textarea"
              disabled
            ></el-input>
          </el-form-item>
        </el-col>
      </el-row>
      <el-form-item class="center" style="width: 134rem">
        <el-button @click="onBack()">返回</el-button>
        <el-button
          type="primary"
          @click="submitForm('ruleForm')"
          v-show="IsEdit == false"
          >处理</el-button
        >
        <!-- <el-button @click="resetForm('')" v-show="IsEdit==false">重置</el-button> -->
      </el-form-item>
    </el-form>
  </div>
</template>
<script>
import MyApis from "../../../apis";
import utils from "../../../../../../utils";
import ZJApp from "../../../../../app";
import { bailoutDetail, saveBailoutInfo } from "@/api/src/resourceApi";
export default {
  name: "HelpInfo",
  controller: "UI",
  action: "HelpInfo",
  data() {
    return {
      ruleForm: {
        CompanyName: "",
        CompanyPhone: "",
      },
      rules: {
        CompanyName: [
          { required: true, message: "请输入单位名称", trigger: "blur" },
        ],
        CompanyPhone: [
          { required: true, validator: this.validphone, trigger: "blur" },
        ],
      },
      IsEdit: false,
      IsAdd: false,
      location: "",
      status: "",
      center: [],
      showResult: true,
    };
  },
  created: function () {
    if (this.$route.query.Id) {
      this.search();
    }
    this.IsEdit = this.$route.query.type == "look" ? true : false;
    this.IsAdd = this.$route.query.type == "add" ? true : false;
  },
  mounted: function () {},
  methods: {
    // 弹出一个错误消息
    errmsg(msg) {
      this.$message({
        showClose: true,
        message: msg || "",
        type: "error",
        customClass: "zj-login-msgbox",
      });
    },
    //返回按钮
    onBack() {
      this.$router.go(-1); //返回上一层
    },
    search() {
      let Id = this.$route.query.Id;
      this.center = [];
      if (Id) {
        let form = new URLSearchParams();
        form.append("id", Id);

        bailoutDetail(form).then((response) => {
          this.ruleForm = response.data;
          this.location = response.data.longitude + response.data.latitude;
          this.status = response.data.status === 1 ? "已处理" : "待处理";
          this.showResult = response.data.status === 1 || this.IsEdit;
          this.center.push(response.data.longitude);
          this.center.push(response.data.latitude);
          this.onDrawMap();
        });
      }
    },
    //保存
    submitForm(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.save();
        } else {
          this.is_login = false;
          this.$message({
            showClose: true,
            message: "请输入必填项",
            type: "error",
            customClass: "zj-login-msgbox",
          });
          return false;
        }
      });
      //this.$router.go(-1); //返回上一层
    },
    validphone: function (rule, value, callback) {
      console.log("validphone");
      if (!value || value.length == 0) {
        callback(new Error("请输入求助电话"));
      } else if (!utils.isRightMobileNum(value)) {
        callback(new Error("请输入正确的手机号"));
      } else {
        callback();
      }
    },
    // submitForm() {
    //   if (!utils.isRightMobileNum(this.ruleForm.CompanyPhone)) {
    //     this.is_login = false;
    //     this.$message({
    //       showClose: true,
    //       message: "请输入正确的手机号",
    //       type: "error",
    //       customClass: "zj-login-msgbox"
    //     });
    //     return;
    //   }
    // },
    save() {
      if (this.$route.query.type == "edit") {
        this.ruleForm.status = 1;
        saveBailoutInfo(this.ruleForm).then((response) => {
          if (response.code == 0) {
            this.$message({
              type: "success",
              message: "处理成功！",
            });
            this.onBack();
          }
        });
      }
    },
    onDrawMap: function () {
      let center = this.center;
      var map = new BMap.Map("allmap");
      var point = new BMap.Point(center[0], center[1]);
      map.centerAndZoom(point, 15);
      var marker = new BMap.Marker(point); // 创建标注
      map.addOverlay(marker); // 将标注添加到地图中
      marker.setAnimation(BMAP_ANIMATION_BOUNCE); //跳动的动画
    },
  },
};
</script>
<style scoped>
.mapBox {
  width: 60%;

  height: 40rem;
  padding: 0px 10px 16px 3px;
  margin-left: 20rem;
  box-sizing: border-box;
  position: relative;
}
</style>
